// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-area {
    height: 928px;
    
    /* 其他样式属性 */
}
`, "",{"version":3,"sources":["webpack://./src/css/ContentArea.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;IAEb,WAAW;AACf","sourcesContent":[".content-area {\r\n    height: 928px;\r\n    \r\n    /* 其他样式属性 */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
